export default __webpack_public_path__ + "static/media/map-type-topographic.21ed5576.png";